import I18nUtils from '@doveconviene/sf-web-js-sdk/i18n/I18nUtils'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'

import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/it'
import '@formatjs/intl-pluralrules/locale-data/fr'
import '@formatjs/intl-pluralrules/locale-data/es'
import '@formatjs/intl-pluralrules/locale-data/pt'
import '@formatjs/intl-pluralrules/locale-data/id'
import '@formatjs/intl-pluralrules/locale-data/de'


import i18nMap from './i18nMap'
import * as messages from './messages'
import * as consts from './consts'

const i18n = new I18nUtils(i18nMap, consts, messages)

export const getI18nMap = language => i18n.getI18nMap(language)

export const getI18nConsts = language => i18n.getI18nConsts(language)

export const getI18nMessages = language => ({
  ...i18n.getI18nMessages('en_us'),
  ...i18n.getI18nMessages(language),
})

export const createI18nPrice = (language, value) => i18n.createI18nPrice(language, value)

export const getI18nKebbabFormat = (language) => {
  const { ISO639, ISO3166_1 } = getI18nMap(language)
  return `${ISO639}-${ISO3166_1}`
}

export const getI18nDefaultFormat = (language) => language.replace('-', '_').toLowerCase()
